import React from 'react'
import { Field } from 'formik'

import { Input as TWInput } from '../../../../../components/Input'

export const Input = props => (
    <div className="mb-[15px]">
        {props?.label?.length > 0 && props?.type !== 'hidden' && (
            <p className="mb-[8px]">
                {props.label}
                {props.required && <sup className="text-brand-danger">*</sup>}
            </p>
        )}

        <Field name={props.name}>
            {({ field, form }) => (
                <TWInput
                    aria-label={props.label}
                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                    isDisabled={form.isSubmitting || props.disabled}
                    value={field.value}
                    {...props}
                />
            )}
        </Field>

        {props?.help?.length > 0 && props?.type !== 'hidden' && (
            <p className="text-brand-dark-grey text-[12px] mb-[15px] md:mb-[30px]">{props.help}</p>
        )}
    </div>
)
